import { IGatsbyImageData } from "gatsby-plugin-image";
import { SbImageOptionProps } from "../SbImage";
import { StoryblokAsset } from "../../../interfaces/StoryblokAsset.interface";
import { getSbImageMetadata, SbImageMetadata } from './getSbImageMetadata.util';
import { getSbGatsbyImageOutputDimensions } from './getSbGatsbyImageOutputDimensions.util';
import { getSbGatsbyImageOutputSizes } from './getSbGatsbyImageOutputSizes.util';
import { getSbGatsbyImageOutputWidths } from './getSbGatsbyImageOutputWidths.util';
import { getSbGatsbyImageSrcSetArray } from './getSbGatsbyImageSrcSetArray.util';
import { getSbGatsbyImageUrl } from './getSbGatsbyImageUrl.util';
import { getSbGatsbyPlaceholderImageUrl } from "./getSbGatsbyPlaceholderImageUrl.util";

export type SbImageLayout = "fixed" | "fullWidth" | "constrained";

export const getSbGatsbyImage = (asset: StoryblokAsset, options?: SbImageOptionProps): IGatsbyImageData => {

    /*-- prop affected values --*/
    const layout: SbImageLayout = options?.objectFit === 'cover' ? 'fullWidth' : 'constrained';
    const quality: number = options?.quality || 80;
    const metadata: SbImageMetadata = getSbImageMetadata(asset);
    const width: number = options?.width || 0;
    const height: number = options?.height || 0;
    const aspectRatio: number = options?.width && options?.height ? options.width / options.height : metadata.aspectRatio;
    const fitIn: boolean = options?.fitIn || false;
    const fitInColour: string = options?.fitInColour && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(options.fitInColour) ? options.fitInColour : 'transparent';
    const smartCrop: boolean = options?.smartCrop || false;

    /*-- private and fixed values --*/
    const _outputPixelDensities: number[] = [2];
    const _breakpoints: number[] = [640, 768, 1024, 1280, 1536];

    /*-- get output widths and heights --*/
    const { outputWidth, outputHeight } = getSbGatsbyImageOutputDimensions(layout, width, height, aspectRatio, metadata);
    const sizes: string = getSbGatsbyImageOutputSizes(outputWidth, layout, options?.sizes, options?.width);
    const widths: number[] = getSbGatsbyImageOutputWidths(layout, _outputPixelDensities, _breakpoints, outputWidth, metadata.width);
    const srcSetArray: string[] = getSbGatsbyImageSrcSetArray(widths, aspectRatio, metadata, asset, quality, fitIn, fitInColour, smartCrop);
    const src: string = getSbGatsbyImageUrl(asset, quality, fitIn, fitInColour, smartCrop);

    /*-- return the expected gatsby image data --*/
    return {
        layout,
        placeholder: {
            sources: [],
            fallback: getSbGatsbyPlaceholderImageUrl(asset)
        },
        backgroundColor: fitInColour,
        images: {
            fallback: {
                src,
                srcSet: srcSetArray.join(',\n') || undefined,
                sizes
            },
            sources: []
        },
        width: outputWidth,
        height: outputHeight
    }
}